import React, { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  folder,
  image_255,
  image_256,
  image_257,
  image_258,
  image_259,
} from "../../../assets/assets";
import Delete from "../../../Modal/Assets/Delete/Delete";
import Folder from "../../../Modal/Assets/Folder/Folder";
import {
  setAddAssestsFolder,
  setGetAssetData,
  setShimmerImg,
  setShowAssets,
  setShowSelectedFolderData,
} from "../../../Redux/Slices/MainSlice";
import httpApiCall from "../../../service/api.service";
import { getStorageValue } from "../../../service/shared.service";
import toastr from "../../elements/toast";
import Assests from "../Assests";
import "./MyAssets.scss";
const toastrService = new toastr(true);

let profileData = getStorageValue("partnerProfile");
profileData = profileData && profileData[0];
const token = getStorageValue("partnerToken");

const MyAssets = ({ onCallApi }: any) => {
  const getAssetData = useSelector(
    (state: any) => state?.assetsData?.getAssetData
  );
  // console.log(getAssetData, "getAssetDatagetAssetData");

  const dispatch = useDispatch();
  const [getAllSelectedFolders, setGetAllSelectedFolders] = useState([
    { name: "", id: 0, selectedIndex: false },
  ]);

  const [allFilesValues, setAllFilesValues] = useState<any>([]);
  const shimmer = useSelector((state: any) => state?.AssetsData.shimmer);
  const Rename = useSelector((state: any) => state?.AssetsData.rename);

  const [createFolderForm, setCreateFolderForm] = useState<any>();
  const [type, setType] = useState(0);
  const [progressWidth, setProgressWidth] = useState(100);
  const [subId, setSubId] = useState(0);
  const [fileId, setFileId] = useState(null);
  const [folderId, setFolderId] = useState(0);
  const [fileType, setFileType] = useState(0);
  const [loader, setLoader] = useState(false);
  const [fileData, setFileData] = useState<any>([]);
  const [editFileld, setEditFileld] = useState(0);
  const [folderType, setFolderType] = useState(0);
  const [showFiles, setShowFiles] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState();
  const [showFilter2, setShowFilter2] = useState(false);
  const [selectedIndex2, setSelectedIndex2] = useState(null);
  const [showProgrssBar, setShowProgrssBar] = useState(false);
  const [showUploadFile, setShowUploadFile] = useState(false);
  const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
  const [showDeleteFolderModal, setShowDeleteFolderModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const [editFolderData, setEditFolderData] = useState();
  const [folderName, setFolderName] = useState<any>();
  const [name_ext, setName_ext] = useState();
  const showAssets = useSelector((state: any) => state?.AssetsData?.showAssets);
  const AssestsFolderDataRedux = useSelector(
    (state: any) => state?.AssetsData?.addAssestsFolder
  );
  const selectedFolder = useSelector(
    (state: any) => state?.AssetsData?.showAssets?.showSelectedFolderData
  );

  const check = useSelector((state: any) => state?.AssetsData);
  // console.log(selectedFolder, "selectedFolderselectedFolder");
  // console.log(AssestsFolderDataRedux, "AssestsFolderDataRedux");

  useEffect(() => {
    dispatch(setShimmerImg(true));
    getAllSelectedFolders.length = 0;
    if (selectedFolder && selectedFolder.id && showAssets) {
      getAllFilesData(selectedFolder?.id);
      setType(1);
      setSubId(0);
      setFolderId(selectedFolder?.id);
      getAllSelectedFolders.push({
        name: selectedFolder.folder_name,
        id: selectedFolder.id,
        selectedIndex: true,
      });
      if (selectedFolder.id) {
        setShowUploadFile(true);
      }
      setEditFolderData(selectedFolder.id);
      setShowProgrssBar(false);
      setShowProgrssBar(true);
    } else {
      setShowFiles(false);
      setShowProgrssBar(false);
    }
    dispatch(setShimmerImg(false));

  }, [selectedFolder]);
  useEffect(() => {
    dispatch(setShimmerImg(true));    
    getAllSelectedFolders.length = 0;
    if (AssestsFolderDataRedux.length || AssestsFolderDataRedux.type) {
      setShowFiles(true);
      setShowProgrssBar(true);
      if(AssestsFolderDataRedux.length){
        getAllSelectedFolders.push({
          name:
            AssestsFolderDataRedux.type == "edit"
              ? AssestsFolderDataRedux.value?.folder_name
              : AssestsFolderDataRedux?.folder_name,
          id:
            AssestsFolderDataRedux.type == "edit"
              ? AssestsFolderDataRedux.value?.id
              : AssestsFolderDataRedux?.id,
          selectedIndex: true,
        });
      }
  
      if (AssestsFolderDataRedux.type == "edit") {
        setShowCreateFolderModal(true);
        setEditFileld(
          AssestsFolderDataRedux?.id
            ? AssestsFolderDataRedux?.id
            : AssestsFolderDataRedux.value?.id
        );
        if (
          AssestsFolderDataRedux.value &&
          AssestsFolderDataRedux.value.folder_name &&
          AssestsFolderDataRedux.value.folder_name.length
        ) {
          setFileType(0);
        } else {
          setFileType(1);
        }
        setSubId(0);
        setFolderName(
          AssestsFolderDataRedux.folder_name
            ? AssestsFolderDataRedux.folder_name
            : AssestsFolderDataRedux.value.folder_name
        );
      } else if (AssestsFolderDataRedux.type == "delete") {
        setFileId(
          AssestsFolderDataRedux?.id
            ? AssestsFolderDataRedux?.id
            : AssestsFolderDataRedux.value?.id
        );
        setFileType(0);
        setShowDeleteFolderModal(true);
        setFolderType(AssestsFolderDataRedux.type);
      }
    }
    dispatch(setShimmerImg(false));

  }, [AssestsFolderDataRedux]);

  useEffect(() => {
    getFolders();
    // setGetAllSelectedFolders([]);
    setTimeout(() => {
      setFolderId(0);
    });
  }, []);

  const goToPage = async (item: any, index: any) => {
    setGetAllSelectedFolders(getAllSelectedFolders.splice(index + 1));
    // getAllSelectedFolders[index]["selectedIndex"] = true;
    setGetAllSelectedFolders(getAllSelectedFolders);
    getAllFilesData(item.id);
  };

  const getData = (item: any) => {
    let folder_id = item?.id;
    getAllSelectedFolders.filter((ele: any) => {
      ele.selectedIndex = false;
    });
    getAllSelectedFolders.push({
      name: item?.folder_name,
      id: item?.id,
      selectedIndex: true,
    });
    setFolderId(item?.id);
    setEditFolderData(item.id);
    getAllFilesData(item?.id);
  };

  const getAllFilesData = async (item?: any, e?: any) => {
    dispatch(setShimmerImg(true));
    const response: any = await getAllFilesDataApi(item);
    if (response.is_error == 0) {
      dispatch(setShimmerImg(false));
    }

    setAllFilesValues(response.data);
    if (response.data) {
      if (!response.data.files.length && !response.data.folders.length) {
        setShowFiles(false);
        setShowProgrssBar(false);
        return;
      }
    }
    if (
      response.data["files"].length > 0 ||
      response.data["folders"].length > 0
    ) {
      setShowFiles(true);
      setShowProgrssBar(true);
    } else {
      if (
        response.data["folders"].length == 0 &&
        response.data["files"].length > 0
      ) {
        setShowFiles(true);
        setShowProgrssBar(false);
      } else if (
        response.data["folders"].length == 0 &&
        response.data["files"].length == 0 &&
        e == 1
      ) {
        setShowFiles(true);
        setShowProgrssBar(false);
      } else {
        setShowFiles(false);
        setShowProgrssBar(false);
      }
    }
  };

  const goToHome = (event: any) => {
    dispatch(setShowAssets(false));
    getFolders();
    setShowFiles(true);
    setShowProgrssBar(false);
    setGetAllSelectedFolders([]);
    setTimeout(() => {
      setFolderId(0);
    }, 1000);
    event.stopPropagation();
  };

  const getFolders = async (e?: any) => {
    dispatch(setShimmerImg(true));
    const repsone: any = await getFoldersApi();
    // setAllFilesValues(repsone.data);
    dispatch(setAddAssestsFolder(repsone.data));
    // dispatch(setShowSelectedFolderData({showSelectedFolderData:repsone.data[repsone.length - 1],}))

    onCallApi();
    setFolderId(0);

    if (repsone.is_error == 0) {
      dispatch(setGetAssetData(repsone.data));
      setGetAllSelectedFolders([]);
      setAllFilesValues([]);
      dispatch(setShimmerImg(false));
      if (repsone.data.length) {
        setTimeout(() => {
          setShowFiles(true);
        }, 100);
      }
    } else {
      setShowUploadFile(false);
      setShowFiles(true);
      setShowProgrssBar(true);
    }
  };

  const uploadSubFolder = () => {
    if (folderId) {
      setSubId(1);
      setShowFiles(true);
      setFolderId(folderId);
      setShowCreateFolderModal(true);
      setType(2);
      setFolderName([]);

      // this.createFolderForm.reset();
      // this.folder.show();
      // this.type = 2;
    } else {
      setSubId(1);
      setShowCreateFolderModal(true);
      setFolderId(0);
      setFolderName([]);

      // this.folder.show();
    }
  };

  const fileChangeEvent = async (event: any, showProgrssBar = false) => {
    if (event && event.target && event.target.files && event.target.files[0]) {
      if (!event.target.files[0].type) {
        toastrService.showError("Invalid file");
        return;
      }
      const file = Math.round(event.target.files[0].size / 1024);
      if (file > 30720) {
        toastrService.showError("Please select a file less than 30mb");
        return;
      }
      setShowProgrssBar(true);
      if (showProgrssBar) {
        setShowFiles(false);
        setShimmerImg(false);
      }
      setFileData(event.target.files[0]);
      const body = {
        access_token: profileData && profileData.access_token,
        assets_file: event.target.files[0],
        partner_id: profileData.partner_id,
        partner_assets_folder_id: folderId,
        name: event.target.files[0]["name"],
      };

      await httpApiCall({
        api: "upload_partner_assets_file",
        type: "form",
        body,
      })
        .then((res: any) => {
          setProgressWidth(100);
          if (res.is_error == 0) {
            setShowProgrssBar(false);
            setShowFiles(true);
            // getAllFilesData(folderId || 0);
            if (folderId == 0) {
              getFolders();
            }
            else{
              getAllFilesData(folderId || 0);

            }
            event.target.value = null;
            // if (allFilesValues.folders.length == 0) {
            // } else {
            // }
          } else if (res.is_error == 1) {
            toastrService.showError("Error uploading");
          }
        })
        .catch((error) => {
          console.log(error, "Error");
        });
    }
  };

  const hideFolders = (id?: any) => {
    setShowCreateFolderModal(false);
    setShowDeleteFolderModal(true);
    if (folderId) {
      getAllFilesData(id);
    }
  };

  const showLabels = (index: any, val: any) => {
    if (val == 1) {
      setSelectedIndex(index);
      setShowFilter(!showFilter);
    } else {
      setSelectedIndex2(index);
      setShowFilter2(!showFilter2);
    }
  };

  const showFolder = (item: any) => {
    setShowCreateFolderModal(true);
    setEditFileld(item.id);
    setType(2);
    setSubId(0);
    if (item.folder_name) {
      setFileType(0);
      setFolderName(item.folder_name);
      setCreateFolderForm({
        ...createFolderForm,
        name: item.folder_name,
      });
    } else {
      let name = item.file_name.split(".");
      setName_ext(name[1]);
      setFileType(1);
      setFolderName(name[0]);
      setCreateFolderForm({
        ...createFolderForm,
        name: name[0],
      });
    }
  };
  const showDeletePopup = (id: any, val: any) => {
    setFileType(val);
    setFileId(id);
    if (val == 1) {
      setFolderType(0);
    }
    setShowDeleteFolderModal(true);
  };
  const showPreview = (url: any) => {

    setShowPreviewModal(true);
  };

  //  const getDownload = (e: any) => {
  //   debugger;
  //   fetch(e.file_name).then((response) => {
  //     response.blob().then((blob) => {

  //         // Creating new object of PDF file
  //         const fileURL = window.URL.createObjectURL(blob);

  //         // Setting various property values
  //         let alink = document.createElement("a");
  //         alink.href = fileURL;
  //         alink.download = "SamplePDF.pdf";
  //         alink.click();
  //     });
  // });

  //  }

  return (
    <>
      <div className="main--wrapper mt-md-5">
        <div className="head--wrapper">
          <div className="name--list ">
            {getAllSelectedFolders && getAllSelectedFolders.length ? (
              <svg
                onClick={(event: any) => goToHome(event)}
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M18.6704 11.0002H16.9984V17.0002C16.9984 17.4452 16.8044 18.0002 15.9984 18.0002H11.9984V12.0002H7.9984V18.0002H3.9984C3.1924 18.0002 2.9984 17.4452 2.9984 17.0002V11.0002H1.3264C0.728397 11.0002 0.856397 10.6762 1.2664 10.2522L9.2904 2.2202C9.4854 2.0182 9.7414 1.9182 9.9984 1.9082C10.2554 1.9182 10.5114 2.0172 10.7064 2.2202L18.7294 10.2512C19.1404 10.6762 19.2684 11.0002 18.6704 11.0002Z"
                  fill="#131921"
                />
              </svg>
            ) : null}
            {getAllSelectedFolders.map((item: any, index: any) => (
              <div
                className={`name ${item?.selectedIndex ? "active" : ""}`}
                onClick={() => goToPage(item, index)}
                key={item.id}
              >
                {/* <span style={{ padding: "0px 2px" }}>
                  {index == 0 ? "/" : ""}
                </span> */}
                <span style={{ padding: "0px 4px" }}>{item?.name}</span>
              </div>
            ))}
            {(!getAllSelectedFolders.length) && (
              <div className="name">
                <svg
                  width="20"
                  height="17"
                  viewBox="0 0 20 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.6704 10.0002H16.9984V16.0002C16.9984 16.4452 16.8044 17.0002 15.9984 17.0002H11.9984V11.0002H7.9984V17.0002H3.9984C3.1924 17.0002 2.9984 16.4452 2.9984 16.0002V10.0002H1.3264C0.728397 10.0002 0.856397 9.6762 1.2664 9.2522L9.2904 1.2202C9.4854 1.0182 9.7414 0.918203 9.9984 0.908203C10.2554 0.918203 10.5114 1.0172 10.7064 1.2202L18.7294 9.2512C19.1404 9.6762 19.2684 10.0002 18.6704 10.0002Z"
                    fill="#131921"
                  />
                </svg>
                <span className="ms-1">All Folder</span>
              </div>
            )}
          </div>
          {
            <div className="button--group">
              <button
                className="button button--revers"
                onClick={() => uploadSubFolder()}
              >
                + Create Folder
              </button>
              {folderId > 0 && (
                <>
                  <button
                    className="button position-relative"
                    // onClick={() => {
                    //   setShowProgrssBar(false);
                    //   setShowFiles(false);
                    // }}
                  >
                    Upload File
                  </button>
                  <input
                    style={{
                      width: "130px",
                      height: "51px",
                      right: "140px",
                      opacity: 0,
                    }}
                    type="file"
                    name="files1"
                    id="files1"
                    className="position-absolute check-upload"
                    accept=".xlsx, .xls, .pdf, .doc, .csv, image/jpg, image/jpeg, image/png, image/svg"
                    onChange={(event: any) => fileChangeEvent(event, true)}
                  />
                </>
              )}
            </div>
          }
        </div>
        {showFiles && showProgrssBar && !shimmer && (
          <div className="row">
            {allFilesValues &&
              allFilesValues.folders?.map((row: any, index: any) => (
                <div className="col-lg-4 col-6" key={index}>
                  <div
                    className="logos-card--media"
                    onClick={() => getData(row)}
                  >
                    <img src={folder} alt="" />
                  </div>
                  <div className="bottom-info">
                    <span>{row?.folder_name}</span>
                    <svg
                      onClick={() => showLabels(index, 1)}
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="25"
                      viewBox="0 0 28 25"
                      fill="none"
                    >
                      <path
                        d="M14.5 14C15.3284 14 16 13.3284 16 12.5C16 11.6716 15.3284 11 14.5 11C13.6716 11 13 11.6716 13 12.5C13 13.3284 13.6716 14 14.5 14Z"
                        fill="#131921"
                      />
                      <path
                        d="M19.5 14C20.3284 14 21 13.3284 21 12.5C21 11.6716 20.3284 11 19.5 11C18.6716 11 18 11.6716 18 12.5C18 13.3284 18.6716 14 19.5 14Z"
                        fill="#131921"
                      />
                      <path
                        d="M9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14Z"
                        fill="#131921"
                      />
                    </svg>
                    {showFilter && selectedIndex == index && (
                      <div
                        className="dropdown-menu"
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        <a
                          className="dropdown-item"
                          onClick={() => showFolder(row)}
                        >
                          Rename
                        </a>
                        <a
                          className="dropdown-item"
                          onClick={() => showDeletePopup(row.id, 0)}
                        >
                          Delete
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            {allFilesValues &&
              allFilesValues?.files?.map((row: any, index: any) => (
                <div className="col-lg-4 col-6" key={index}>
                  <div className="logos-card--wrap">
                    <div>
                      <div className="logos-card--media">
                        {!row.file_name.includes(".pdf") &&
                          !row.file_name.includes(".doc") &&
                          !row.file_name.includes(".ppt") &&
                          !row.file_name.includes(".xlsx") &&
                          !row.file_name.includes(".csv") && (
                            <img src={row.file_url} alt="file" />
                          )}
                        {row.file_name.includes(".pdf") && (
                          <img src={image_255} alt="" />
                        )}
                        {row.file_name.includes(".doc") && (
                          <img src={image_256} alt="" />
                        )}
                        {row.file_name.includes(".ppt") && (
                          <img src={image_257} alt="" />
                        )}
                        {row.file_name.includes(".xlsx") && (
                          <img src={image_258} alt="" />
                        )}
                        {row.file_name.includes(".csv") && (
                          <img src={image_259} alt="" />
                        )}
                        {/* {row.file_name.includes('.png') && <img src={folder} alt="" />} */}
                      </div>
                      <div className="bottom-info">
                        <span>{row.file_name}</span>
                        <svg
                          onClick={() => showLabels(index, 2)}
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="25"
                          viewBox="0 0 28 25"
                          fill="none"
                        >
                          <path
                            d="M14.5 14C15.3284 14 16 13.3284 16 12.5C16 11.6716 15.3284 11 14.5 11C13.6716 11 13 11.6716 13 12.5C13 13.3284 13.6716 14 14.5 14Z"
                            fill="#131921"
                          />
                          <path
                            d="M19.5 14C20.3284 14 21 13.3284 21 12.5C21 11.6716 20.3284 11 19.5 11C18.6716 11 18 11.6716 18 12.5C18 13.3284 18.6716 14 19.5 14Z"
                            fill="#131921"
                          />
                          <path
                            d="M9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14Z"
                            fill="#131921"
                          />
                        </svg>
                        {showFilter2 && selectedIndex2 == index && (
                          <div
                            className="dropdown-menu dropmenu"
                            onClick={() => setShowFilter2(!showFilter2)}
                          >
                            {!row.file_name.includes(".pdf") &&
                              !row.file_name.includes(".doc") &&
                              !row.file_name.includes(".ppt") &&
                              !row.file_name.includes(".xlsx") &&
                              !row.file_name.includes(".csv") && (
                                <Link
                                  to={row.file_url}
                                  className="dropdown-item"
                                  onClick={() => showPreview(row.file_url)}
                                  target="_blank"
                                >
                                  Preview
                                </Link>
                              )}
                            {(row.file_name.includes(".pdf") ||
                              row.file_name.includes(".doc") ||
                              row.file_name.includes(".ppt") ||
                              row.file_name.includes(".xlsx") ||
                              row.file_name.includes(".csv")) && (
                              <a
                                className="dropdown-item"
                                target={`${ !row.file_name.includes(".pdf") ? "_self" : "_blank"}`}
                                href={row.file_url}
                                download
                              >
                                Download
                              </a>
                            )}

                            <a
                              className="dropdown-item"
                              onClick={() => showFolder(row)}
                            >
                              Rename
                            </a>
                            <a
                              className="dropdown-item"
                              onClick={() => showDeletePopup(row.id, 1)}
                            >
                              Delete
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
        <div className="upload--wrapper">
          {!showFiles && !showProgrssBar && !shimmer && (
            <div className="file-dropbox">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
              >
                <path
                  d="M30.6693 41.5383V18.4717L24.4559 24.685L22.5679 22.7677L32.0026 13.333L41.4373 22.7677L39.5519 24.6877L33.3359 18.4717V41.5383H30.6693ZM17.6426 50.6663C16.4159 50.6663 15.3919 50.2557 14.5706 49.4343C13.7475 48.6112 13.3359 47.5863 13.3359 46.3597V39.8983H16.0026V46.3597C16.0026 46.7686 16.1733 47.1446 16.5146 47.4877C16.8577 47.829 17.2337 47.9997 17.6426 47.9997H46.3626C46.7715 47.9997 47.1475 47.829 47.4906 47.4877C47.8319 47.1446 48.0026 46.7686 48.0026 46.3597V39.8983H50.6693V46.3597C50.6693 47.5863 50.2586 48.6103 49.4373 49.4317C48.6142 50.2548 47.5893 50.6663 46.3626 50.6663H17.6426Z"
                  fill="black"
                />
              </svg>
              <span>Drop files here to upload</span>
              <input
                type="file"
                name="files1"
                id="files1"
                accept=".xlsx, .xls, .pdf, .doc, .csv, image/jpg, image/jpeg, image/png, image/svg"
                onChange={(event: any) => fileChangeEvent(event)}
              />
            </div>
          )}
          {showProgrssBar && !showFiles && !shimmer && (
            <div className="file-dropbox file-dropbox-v2">
              <label>Uploading</label>
              <div className="uploading--list">
                <div className="uploading--list--item">
                  <span className="d-block file--name">{fileData.name}</span>
                  <span className="d-block file--size">
                    {(fileData.size / 1000).toFixed(2)} KB
                  </span>
                  <div className="progress--wrapper">
                    <ProgressBar now={progressWidth} />
                    <span>{progressWidth}%</span>
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M15.625 4.375L4.375 15.625"
                        stroke="#596775"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.625 15.625L4.375 4.375"
                        stroke="#596775"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {showCreateFolderModal && (
        <Folder
          loader={loader}
          show={showCreateFolderModal}
          hideFolders={(id: any) => hideFolders(id)}
          getFolders={() => getFolders()}
          getAllFilesData={(item: any, e: any) => getAllFilesData(item, e)}
          onHide={() => {
            setShowCreateFolderModal(false);
          }}
          createFolderForm={createFolderForm}
          subId={subId}
          editFolderData={editFolderData}
          folderId={folderId}
          type={type}
          fileType={fileType}
          fileId={fileId}
          editFileld={editFileld}
          folderType={folderType}
          folderName={folderName}
          nameExt= {name_ext}
        />
      )}
      {showDeleteFolderModal && (
        <Delete
          fileId={fileId}
          fileType={fileType}
          folderId={folderId}
          folderType={folderType}
          getFolders={() => getFolders()}
          show={showDeleteFolderModal}
          hideFolders={(id: any) => hideFolders(id)}
          onHide={() => setShowDeleteFolderModal(false)}
          getallfilesdata={(item: any, e: any) => getAllFilesData(item, e)}
          navigateToHome={
            AssestsFolderDataRedux.navigateToHome
              ? AssestsFolderDataRedux.navigateToHome
              : false
          }
        />
      )}
    </>
  );
};

export default MyAssets;

const getAllFilesDataApi = async (val: any) => {
  let body = {
    access_token: token,
    partner_id: profileData.partner_id,
    partner_assets_folder_id: val,
  };
  const res = await httpApiCall({
    api: "get_assets_files",
    type: "post",
    body,
  });

  if (res.is_error == 0) {
    return res;
  } else {
    toastrService.showError(res.err);
  }
};

const getFoldersApi = async () => {
  let body = {
    access_token: token,
    partner_id: profileData.partner_id,
  };

  const res = await httpApiCall({
    api: "get_assets_folders",
    type: "post",
    body,
  });

  if (res.is_error == 0) {
    return res;
  } else {
    toastrService.showError(res.err);
  }
};
